import { render, staticRenderFns } from "./Cm-trends.vue?vue&type=template&id=c1b9f2cc"
import script from "./Cm-trends.vue?vue&type=script&lang=js"
export * from "./Cm-trends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports